import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/ResetPassword";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ResetPasswordTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="ResetPassword">
      <TabletNotice page="ResetPassword" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default ResetPasswordTablet;